import * as ActionTypes from 'actions/bankTransferForm'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  bankDetail: {},
  bankTransfers: [],
  bankAccounts: [],
}

// Updates error message to notify about the failed fetches.
export default function bankTransferForm(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.BANKDETAIL_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.BANKDETAIL_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        bankDetail: action.bankDetail,
      }
    case ActionTypes.BANKTRANSFERS_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        bankTransfers: action.bankTransfers,
      }
     case ActionTypes.BANKACCOUNTS_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        bankAccounts: action.bankAccounts,
      }
    case ActionTypes.BANKTRANSFER_SAVE_REQUEST:
      return Object.assign({}, state, {
        // isFetching: true,
      })
    case ActionTypes.BANKTRANSFER_SAVE_COMPLETE:
      return {
        ...state,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/bankTransferForm.js